import React, { useEffect, useRef } from "react";

import { Button } from "antd";
import Modal from "antd/es/modal/Modal";
// eslint-disable-next-line import/no-extraneous-dependencies
import Lottie from "lottie-react";

import SuccessAnimationData from "../../../../../assets/images/common/animation/SuccessAnimation.json";
import "./ReleaseTestSuccessModal.css";

export default function ReleaseTestSuccessModal({ testName = "", onDone }) {
  const lottieRef = useRef(null);
  const releasedTestLabel = (testName || "").toString().trim();
  const heading = releasedTestLabel
    ? `Test Results for ${releasedTestLabel} Released Successfully`
    : "Test Results Released Successfully";

  const playSuccessAnimation = () => {
    if (lottieRef.current) {
      lottieRef.current.goToAndPlay(0, true);
    }
  };

  useEffect(() => {
    const timer = window.setTimeout(playSuccessAnimation, 200);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    <Modal
      open
      maskClosable={false}
      closable={false}
      centered
      footer={null}
      afterOpenChange={(isOpen) => {
        if (isOpen) playSuccessAnimation();
      }}
      wrapClassName="ReleaseTestSuccessModalWrap"
      className="ReleaseTestSuccessModal"
      width={591}
    >
      <div className="ReleaseTestSuccessModal__Content">
        <div className="ReleaseTestSuccessModal__Gif" aria-hidden>
          <Lottie
            lottieRef={lottieRef}
            animationData={SuccessAnimationData}
            loop={false}
            autoplay={false}
          />
        </div>

        <p className="ReleaseTestSuccessModal__Heading">
          {heading}
        </p>

        <Button
          type="primary"
          className="ReleaseTestSuccessModal__Done"
          onClick={onDone}
        >
          Done
        </Button>
      </div>
    </Modal>
  );
}
